module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/da.ed15f9fb.png";